module.exports = '3.3.1';



// WEBPACK FOOTER //
// ./node_modules/@feathersjs/feathers/lib/version.js